// pages/FormViewerPage/components/VariantOptions/RadioOption.tsx — Radio style variant
import React from 'react';
import type { Form } from '../../../../types';
import { formatMoney } from '../../../../utils/formatMoney';
import { singleLockGroup } from '../../../../utils/regionPricing';
import type { ProductOption, VariantCombination } from './types';

export const RadioOption: React.FC<{
    option: ProductOption;
    selectedOptions: Record<string, string>;
    onOptionChange: (name: string, value: string) => void;
    getVariantDetails: (name: string, val: string) => VariantCombination | null;
    variantStock: Record<string, number>;
    form: Form;
}> = ({ option, selectedOptions, onOptionChange, getVariantDetails, variantStock, form }) => (
    <div className="divide-y divide-slate-100 dark:divide-slate-700/50 border-y border-slate-100 dark:border-slate-700/50">
        {option.values.map(val => {
            const details = getVariantDetails(option.name, val);
            const isSelected = selectedOptions[option.name] === val;

            return (
                <label
                    key={val}
                    className={`flex items-center justify-between gap-2 px-1 py-2.5 cursor-pointer transition-colors ${isSelected
                        ? 'bg-orange-50/60 dark:bg-orange-900/20'
                        : ''
                        }`}
                >
                    <div className="flex items-center gap-3">
                        <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${isSelected ? 'border-orange-600' : 'border-slate-300 dark:border-slate-500'}`}>
                            {isSelected && <div className="w-2.5 h-2.5 rounded-full bg-orange-600" />}
                        </div>
                        <input
                            type="radio"
                            name={option.name}
                            value={val}
                            checked={isSelected}
                            onChange={(e) => onOptionChange(option.name, e.target.value)}
                            className="hidden"
                        />
                        <div className="flex items-center gap-1.5 flex-wrap">
                            <span className="font-medium">{val}</span>
                            {form?.defaultVariant === val && (
                                <span className="text-[10px] font-bold px-1.5 py-0.5 rounded-full bg-amber-100 dark:bg-amber-950/60 text-amber-800 dark:text-amber-200 border border-amber-300 dark:border-amber-700">
                                    ⭐ Rekomendasi
                                </span>
                            )}
                        </div>
                    </div>
                    {option.showPrice !== false && (!(form.productRegionGroups?.length) || singleLockGroup(form)) && details?.sellingPrice != null && (
                        <span className="text-sm font-semibold whitespace-nowrap text-slate-700 dark:text-slate-300">
                            {formatMoney(details.sellingPrice, form)}
                            {details.strikethroughPrice != null && details.strikethroughPrice > details.sellingPrice && (
                                <span className="ml-1.5 text-xs font-normal text-slate-400 line-through">{formatMoney(details.strikethroughPrice, form)}</span>
                            )}
                        </span>
                    )}
                </label>
            );
        })}
    </div>
);
